import { switchAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  switchAnatomy.keys
);

const baseTrackStyle = defineStyle({
  _checked: {
    bg: "brand.analytic",
  },
});

const baseStyle = definePartsStyle({
  track: baseTrackStyle,
});

export const switchTheme = defineMultiStyleConfig({ baseStyle });
